<script setup lang="ts">
const props = withDefaults(defineProps<{ columns?: number }>(), { columns: 4 });

const items = computed(() =>
  Array.from({ length: 20 }).map((_, index) => ({
    index,
    column: index % props.columns,
  }))
);

const { isMobile } = useUserDevice();
</script>

<template>
  <div class="grid lg:grid-cols-4 gap-10">
    <template v-if="isMobile">
      <div v-for="item in items" :key="item.index">
        <PostGridLoader :key="`loading-${item.index}`" />
      </div>
    </template>

    <template v-else>
      <div
        v-for="(_, col) in props.columns"
        class="flex flex-col items-stretch justify-start gap-10"
      >
        <div
          v-for="item in items.filter((i) => i.column === col)"
          :key="item.index"
        >
          <PostGridLoader :key="`loading-${item.index}`" />
        </div>
      </div>
    </template>
  </div>
</template>
